module.exports = function getRatio() {
  return window.devicePixelRatio ? window.devicePixelRatio : 2;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/dom/get-ratio.js
// module id = 186
// module chunks = 0